





















import {Component, Vue, Prop} from "vue-property-decorator";

import {NamedOption} from "@/util/NamedOption";

import FormBase from "@/components/Form/InputComponents/FormBase.vue";


@Component({})
export default class FormRadio extends FormBase {
  @Prop({required:true}) options!:NamedOption[];

}
